import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { ToastProvider } from '@/components/ui/overlays';
import { AuthProvider } from '@/features/auth/auth-context';
import { ThemeProvider } from '@/features/theme/theme-context';
import { ApiError } from '@/lib/api-client';
import { App } from './App';
import './styles/theme.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Les données du domaine changent au rythme des lots, pas à la seconde :
      // 30 s de fraîcheur évitent une avalanche de requêtes à chaque navigation.
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Réessayer une erreur d'autorisation ou de validation ne peut pas
        // aboutir : seules les défaillances transitoires méritent une reprise.
        if (error instanceof ApiError && error.statusCode < 500) return false;
        return failureCount < 2;
      },
    },
    mutations: { retry: false },
  },
});

const container = document.getElementById('root');
if (!container) {
  throw new Error('Élément racine introuvable.');
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <ToastProvider>
          <BrowserRouter>
            <AuthProvider>
              <App />
            </AuthProvider>
          </BrowserRouter>
        </ToastProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
);
